import {
  Directive,
  ElementRef,
  effect,
  inject,
  input,
  output,
  signal,
} from '@angular/core';
import { coerceBoolean } from '../../cdk/utils';
import { DropdownComponent } from './dropdown.component';

@Directive({
  selector: '[tvdDropdownItem]',
  host: {
    role: 'listitem',
    class: ' focus:outline-none',
    '[class.text-neutrals-700]': 'disabled()',
    '[class.bg-neutrals-300]': 'disabled()',
    '[class.cursor-pointer]': '!disabled()',
    '[class.hover:bg-select]': '!disabled()',
    '[class.!bg-primary-200]': 'highlighted()',
    '[class.bg-primary-300]': 'active()',
    '(click)': 'onFocus(); $event.preventDefault(); $event.stopPropagation()',
    '(keydown.enter)':
      'onFocus(); $event.preventDefault(); $event.stopPropagation();',
    '[attr.tabindex]': 'active() ? 0 : -1',
  },
})
export class DropdownItemDirective {
  readonly disabled = input(false, { transform: coerceBoolean });
  readonly active = input(false, { transform: coerceBoolean });
  readonly focused = output();

  readonly highlighted = signal(false);

  readonly #host: HTMLElement = inject(ElementRef).nativeElement;

  readonly #dropdown = inject(DropdownComponent);

  readonly #items = this.#dropdown.items;

  readonly #activeEffect = effect(() => {
    if (this.highlighted()) {
      this.scrollIntoView();
    }
  });

  scrollIntoView() {
    this.#host.scrollIntoView({ block: 'center', inline: 'center' });
    this.#host.focus();
  }

  onFocus() {
    if (!this.disabled()) {
      this.focused.emit();
      if (this.#dropdown.closeOnSelect()) {
        this.#dropdown.close();
      }
    }
  }
}
